import Vue from "vue";

Vue.directive('trans', {
   bind (el, binding, _vnode) {
       el.innerHTML=gettext(binding.value);
       el.removeAttribute("data-trans");
   }
})

Vue.directive('on-escape', {
    bind (el, binding, vnode) {
        el.customEventKeydown = function (event) {
            if (event?.keyCode === 27) {
                vnode?.context[binding.expression](event)
            }
        }
        document.body.addEventListener("keydown", el.customEventKeydown)
    },
    unbind (el) {
        document.body.removeEventListener("keydown", el.customEventKeydown)
    }
})

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
      el.clickOutsideEvent = function(event) {
        // Check if the click was outside the el and its children
        if (!(el == event.target || el.contains(event.target))) {
          // Call the method provided to the directive
          vnode.context[binding.expression](event);
        }
      };
      document.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
      // Clean up the event listener
      document.removeEventListener('click', el.clickOutsideEvent);
    },
  });